module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowLeft.10a2c9fa.svg";